<template>
    <q-menu v-model="model">        
        <q-card class="dialogWidth">
            <q-card-section>
                <div class="text-h6">{{ label }}</div>
            </q-card-section>
            <q-card-actions>
                <q-space />
                <q-btn color="primary" @click="emits('confirm')" icon="check">確定</q-btn>
                <q-btn color="warning" @click="cancel" icon="close">取消</q-btn>
            </q-card-actions>
        </q-card>
    </q-menu>
</template>
<script setup>
import {ref} from 'vue';
let model=ref(false);
defineProps({
    label: {
        type: String,
        default: null
    }
})
const cancel=()=>{
    model.value=false;
    emits('cancel');
}
const emits = defineEmits(['confirm', 'cancel']);
</script>
<style scoped>
.dialogWidth{
    width: 300px;
}
</style>
